import classNames from 'classnames';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

/** isExpanded=true：侧栏展开，点击收起；false：图标栏，点击展开 */
export function QuickLinksPanelToggleIcon({ className, isExpanded = true }) {
	return (
		<svg
			className={classNames('dashboard-quick-links-panel-icon dashboard-quick-links-header-icon', className, {
				'dashboard-quick-links-panel-icon--collapsed': !isExpanded,
			})}
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			aria-hidden='true'
		>
			<rect x='1.5' y='2.5' width='13' height='11' rx='1.5' stroke='currentColor' strokeWidth='1.25' />
			<rect x='3' y='4' width='3.5' height='8' rx='0.5' fill='currentColor' />
		</svg>
	);
}

QuickLinksPanelToggleIcon.propTypes = {
	className: PropTypes.string,
	isExpanded: PropTypes.bool,
};

/** 两道横杠，与 QuickLinksPanelToggleIcon 同规格 */
export function QuickLinksCustomizeIcon({ className }) {
	return (
		<svg className={classNames('dashboard-quick-links-header-icon', className)} width='16' height='16' viewBox='0 0 16 16' fill='none' aria-hidden='true'>
			<path d='M3 6h10' stroke='currentColor' strokeWidth='1.25' strokeLinecap='round' />
			<path d='M3 10h10' stroke='currentColor' strokeWidth='1.25' strokeLinecap='round' />
		</svg>
	);
}

QuickLinksCustomizeIcon.propTypes = {
	className: PropTypes.string,
};

/** 快速链接标题栏图标按钮：样式/交互统一，仅 icon 不同 */
export function QuickLinksHeaderIconButton({ icon, label, onClick, planB = false, tooltipPlacement = 'left', className, ariaExpanded }) {
	return (
		<OverlayTrigger placement={tooltipPlacement} overlay={<Tooltip className='dashboard-quick-links-panel-toggle__tooltip'>{label}</Tooltip>}>
			<button
				type='button'
				className={classNames(
					'dashboard-quick-start__collapse-btn dashboard-quick-links-panel-toggle flex-shrink-0 p-0 border-0',
					planB ? 'dashboard-quick-start__collapse-btn--plan-b' : 'text-white dark__text-white',
					className,
				)}
				onClick={onClick}
				aria-label={label}
				{...(typeof ariaExpanded === 'boolean' ? { 'aria-expanded': ariaExpanded } : {})}
			>
				{icon}
			</button>
		</OverlayTrigger>
	);
}

QuickLinksHeaderIconButton.propTypes = {
	icon: PropTypes.node.isRequired,
	label: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	planB: PropTypes.bool,
	tooltipPlacement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
	className: PropTypes.string,
	ariaExpanded: PropTypes.bool,
};
